import { buildColMeta, useTableSearch } from '@/components/custom/erp/data-table-v2';
import { DATA_TABLE_BASE_COLS } from '../cols-definition';
import { QUERY_KEYS } from '@/constants/query-keys';
import { TABLE_PAGE_SIZE } from '../constants';
import { SearchFormValues } from '../schema';

interface UseSearchTableProps {
  searchData: (filters: Record<string, MuaHangRecord>, page?: number, searchPageSize?: number) => Promise<void>;
  searchParams: SearchFormValues;
  setSearchParams: (params: SearchFormValues) => void;
  isFiltered: boolean;
  handlePageChange: (page: number) => Promise<void>;
}

export const useSearchTable = ({
  searchData,
  searchParams,
  setSearchParams,
  isFiltered,
  handlePageChange
}: UseSearchTableProps) => {
  return useTableSearch<SearchFormValues>({
    endpoint: `${QUERY_KEYS.HOA_DON_MUA_HANG_TRONG_NUOC}/filter`,
    pageSize: TABLE_PAGE_SIZE,
    sumField: 't_tt_nt',
    searchData,
    searchParams,
    setSearchParams,
    isFiltered,
    handlePageChange,
    getColumnMeta: () => buildColMeta(DATA_TABLE_BASE_COLS)
  });
};
